
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { LogOut } from 'lucide-react';

interface LeavePortfolioDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  source?: 'portfolio' | 'business';
}

const LeavePortfolioDialog: React.FC<LeavePortfolioDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  source = 'portfolio'
}) => {
  const [confirmText, setConfirmText] = useState('');
  const isConfirmEnabled = confirmText === 'I\'m Out!';
  
  // Text based on source context
  const title = source === 'portfolio' ? 'Leave Portfolio' : 'Leave Business';
  const description = source === 'portfolio'
    ? 'Are you sure you want to leave this portfolio?'
    : 'Are you sure you want to leave this business?';
  
  const handleConfirmClick = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader className="gap-2">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
            <LogOut className="h-6 w-6 text-red-600" />
          </div>
          <DialogTitle className="text-center text-xl">{title}</DialogTitle>
          <DialogDescription className="text-center">
            {description}
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-3">
          <p className="mb-2 text-sm font-medium">Type "I'm Out!" to confirm</p>
          <Input 
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="I'm Out!"
            className="w-full"
          />
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="w-full sm:w-auto">
            Cancel
          </Button>
          <Button 
            onClick={handleConfirmClick} 
            disabled={!isConfirmEnabled}
            variant="destructive"
            className="w-full sm:w-auto"
          >
            {title}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LeavePortfolioDialog;
